"use client";

import Link from 'next/link';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function NavigationButton() {
  return (
    <nav aria-label="Blog navigation" className="mb-8">
      {/* asChild renders the Button's styling onto the Link itself. The
          previous form nested a <button> inside an <a>, which is invalid HTML —
          interactive content cannot contain interactive content — and left the
          anchor as an 18px inline box wrapped around a 44px control. */}
      <Button variant="outline" className="no-underline" asChild>
        <Link href="/blog" className="inline-flex items-center">
          <ChevronLeft className="h-4 w-4 mr-2" aria-hidden="true" />
          Back to all posts
        </Link>
      </Button>
    </nav>
  );
}
